import { render, staticRenderFns } from "./ShVxeTable.md?vue&type=template&id=b9728ace"
import script from "./ShVxeTable.md?vue&type=script&lang=js"
export * from "./ShVxeTable.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports